import { Card } from '@/components/ui/card';
import { ShoppingCart, Store, Building, Home, Warehouse } from 'lucide-react';
import { Link } from 'react-router-dom';

export const AssetClassCards = () => {
  const assetClasses = [
    {
      icon: ShoppingCart,
      title: 'Lebensmittelmärkte',
      description:
        'Supermarkt-Immobilien mit langfristigen Mietverträgen von etablierten Betreibern.',
      link: '/assetklassen/lebensmittelmaerkte',
      image: 'https://images.pexels.com/photos/264507/pexels-photo-264507.jpeg?auto=compress&cs=tinysrgb&w=600',
    },
    {
      icon: Store,
      title: 'Discounter und Drogerie',
      description:
        'Filialen von Discount-Ketten und Drogeriemarkt-Betreibern mit stabilen Cashflows.',
      link: '/assetklassen/discounter-drogerie',
      image: 'https://images.pexels.com/photos/6141082/pexels-photo-6141082.jpeg?auto=compress&cs=tinysrgb&w=600',
    },
    {
      icon: Building,
      title: 'Fachmärkte und Baumärkte',
      description:
        'Großflächige Einzelhandelsimmobilien für spezialisierte Sortimente.',
      link: '/assetklassen/fachmaerkte-bau',
      image: 'https://images.unsplash.com/photo-1726866492047-7f9516558c6e?auto=compress&cs=tinysrgb&w=600',
    },
    {
      icon: Home,
      title: 'Fachmarktzentren',
      description:
        'Retail Parks mit mehreren Ankermieter und diversifiziertem Mietermix.',
      link: '/assetklassen/fachmarktzentren',
      image: 'https://images.unsplash.com/photo-1595879171931-4ca27febc4bf?auto=compress&cs=tinysrgb&w=600',
    },
    {
      icon: Warehouse,
      title: 'Großflächen und Sonderformate',
      description:
        'SB-Warenhäuser, Cash & Carry und andere großflächige Handelsformate.',
      link: '/assetklassen/grossflaechen',
      image: 'https://images.unsplash.com/photo-1726866672851-5b99c837603c?auto=compress&cs=tinysrgb&w=600',
    },
  ];

  return (
    <section className="py-24 bg-white" data-testid="asset-class-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block">
            <div className="w-16 h-1 bg-gradient-to-r from-[#D4A853] to-[#F0C870] mb-4 mx-auto"></div>
          </div>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4"
            style={{ color: 'var(--navy-900)' }}
          >
            Unsere Assetklassen
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: 'var(--gray-600)' }}>
            Spezialisiert auf verschiedene Arten von Handelsimmobilien
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {assetClasses.map((assetClass, index) => {
            const IconComponent = assetClass.icon;
            return (
              <Link
                key={index}
                to={assetClass.link}
                data-testid={`asset-card-${index}`}
                className="group"
              >
                <Card className="glass-card h-full overflow-hidden hover:shadow-2xl transition-all duration-300 border-t-4" style={{ borderTopColor: 'var(--gold-600)' }}>
                  {/* Image */}
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={assetClass.image}
                      alt={assetClass.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/80 to-transparent"></div>
                    
                    {/* Icon Badge */}
                    <div
                      className="absolute top-4 right-4 w-12 h-12 rounded-full flex items-center justify-center shadow-lg"
                      style={{ backgroundColor: 'var(--gold-600)' }}
                    >
                      <IconComponent className="h-6 w-6 text-white" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3
                      className="text-xl font-bold mb-3 group-hover:text-[#D4A853] transition-colors"
                      style={{ color: 'var(--navy-800)' }}
                    >
                      {assetClass.title}
                    </h3>
                    <p className="text-sm leading-relaxed" style={{ color: 'var(--gray-600)' }}>
                      {assetClass.description}
                    </p>
                  </div>
                </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};